export default function Footer() {
  return (
    <footer>
      <div className="mx-auto flex max-w-[1280px] flex-col gap-3 px-6 py-10 font-mono text-[12px] uppercase tracking-[0.14em] text-fg-muted md:flex-row md:items-center md:justify-between md:px-10">
        <p>&copy; {new Date().getFullYear()} · neXenio GmbH · Berlin</p>
        <nav className="-mx-2 flex flex-wrap items-center">
          <a
            href="https://www.nexenio.com"
            className="inline-flex min-h-[44px] items-center px-2 hover:text-fg"
          >
            nexenio.com
          </a>
          <a
            href="https://www.nexenio.com/impressum"
            className="inline-flex min-h-[44px] items-center px-2 hover:text-fg"
          >
            Impressum
          </a>
          <a
            href="https://www.nexenio.com/wp-content/uploads/2025/09/Datenschutzerklarung-neXenio-DE-092025_.pdf"
            className="inline-flex min-h-[44px] items-center px-2 hover:text-fg"
          >
            Datenschutz
          </a>
        </nav>
      </div>
    </footer>
  );
}
